import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'app-contenus-management',
    templateUrl: './contenus-management.component.html',
    styleUrls: ['./contenus-management.component.scss'],
    imports: [
        CommonModule,
        MatIconModule,
        RouterOutlet,
        TranslateModule,
        MatButtonModule,
        MatMenuModule
    ]
})
export class ContenusManagementComponent implements OnInit {
  utilisateurId: number = 0;
  provenance: string = "";
  page: string = "";
  isLoading: boolean = true;
  hasData: boolean = false;
  filter: 'complete' | 'encours' = 'complete';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    window.addEventListener('data-loaded', (event: any) => {
      this.isLoading = false;
      if (event.detail && event.detail.hasData !== undefined) {
        this.hasData = event.detail.hasData;
      }
    });
    
    if(window.location.pathname.includes('encours')){
      this.filter = 'encours';
    } else if (window.location.pathname.includes('complete')) {
      this.filter = 'complete';
    }

    if (window.location.pathname.includes('profil-utilisateur')) {
      this.utilisateurId = Number.parseInt(window.location.pathname.split('/').pop()!);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('data-loaded', (event: any) => { });
  }

  setFilter(newFilter: 'complete' | 'encours'): void {
    this.filter = newFilter;
    this.isLoading = true;
    this.hasData = false;
    if (window.location.pathname.includes('profil-utilisateur')) {
       this.router.navigate([this.filter, this.utilisateurId], { relativeTo: this.route });
    } else  {
       this.router.navigate([this.filter], { relativeTo: this.route });
    }
  }
  exporterVersExcel(): void {
    const event = new CustomEvent('export-excel', { detail: { filter: this.filter } });
    window.dispatchEvent(event);
  }

  exporterVersPdf(): void {
    const event = new CustomEvent('export-pdf', { detail: { filter: this.filter } });
    window.dispatchEvent(event);
  }
}
